<template>
  <v-text-field
    v-bind="computedProps"
    v-on="$listeners"
    outlined
  ></v-text-field>
</template>

<script>
import { VTextField } from "vuetify/lib";
export default {
  name: "STextField",
  extends: VTextField,
  props: {
    label: {
      type: String,
      default: "label"
    },
    icon: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primaryColor",
    },
    date: {
      type: Boolean,
      default: false
    },
    time: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedProps() {
      return {
        ...this.$props,
        label: this.label,
        prependIcon: this.choosenIcon,
        color: this.color,
      };
    },
    choosenIcon() {
      if(this.date && this.icon == '') return 'fa-calendar';
      else if(this.time && this.icon == '') return 'fa-stopwatch'
      else return this.icon;
    }
  },
};
</script>

<style></style>
